<template>
    <BModal ref="modal" :title="$t('aperioLockModal.title')" centered scrollable header-class="modal-title" modal-class="no-border-modal" @hidden="onHidden">
        <div v-for="(lock, index) in locks" :key="lock.device_group_id" class="form-check mb-2">
            <input :id="`aperio-lock-${index}`" class="form-check-input" type="radio" name="aperio-lock" :value="index" v-model="selectedIndex" />
            <label class="form-check-label" :for="`aperio-lock-${index}`">
                <span class="fw-bold text-primary">{{ lockLabel(lock) }}</span>
                <span v-if="lock.mac" class="d-block font-13 text-muted">{{ lock.mac }}</span>
            </label>
        </div>
        <template #footer>
            <div class="d-flex justify-content-between align-items-center w-100">
                <button type="button" class="btn btn-secondary" @click="close(null)">{{ $t('common.cancel') }}</button>
                <button type="button" class="btn btn-primary ms-2" :disabled="selectedIndex === null" @click="close(locks[selectedIndex])">{{ $t('common.ok') }}</button>
            </div>
        </template>
    </BModal>
</template>

<script>
import { BModal } from 'bootstrap-vue-next';
import { ref } from 'vue';

// Aperio locks a reader can be moved to, the current one first.
// show() resolves with the selected lock, or null when cancelled.
export default {
    name: 'AperioLockModal',
    components: {
        BModal
    },
    setup() {
        const modal = ref(null);
        const locks = ref([]);
        const selectedIndex = ref(null);
        let resolver = null;

        const show = (availableLocks, currentLock) => {
            locks.value = availableLocks;
            const index = currentLock ? availableLocks.indexOf(currentLock) : -1;
            selectedIndex.value = index >= 0 ? index : null;
            modal.value.show();
            return new Promise(resolve => { resolver = resolve; });
        };

        const close = (result) => {
            const resolve = resolver;
            resolver = null;
            modal.value.hide();
            if (resolve) resolve(result);
        };

        const onHidden = () => {
            if (resolver) close(null);
        };

        const lockLabel = (lock) => lock.name ? `${lock.name} (${lock.device_group_id})` : lock.device_group_id;

        return {
            modal,
            locks,
            selectedIndex,
            show,
            close,
            onHidden,
            lockLabel,
        };
    }
}
</script>
